import React from "react";
import ReactDOM from "react-dom/client";
import { theme } from "./assets/js/theme";
import { BrowserRouter } from "react-router-dom";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import App from "./App";

import "./assets/css/fonts.css";
import "./assets/css/global.css";
import { HelmetProvider } from "react-helmet-async";
import AppContextProvider from "./contexts/AppContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <BrowserRouter>
                <ThemeProvider theme={theme}>
                    <StyledEngineProvider injectFirst>
                        <AppContextProvider>
                            <App />
                        </AppContextProvider>
                    </StyledEngineProvider>
                </ThemeProvider>
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>
);
